import userService from "./userService";
import { DAYS } from "./common/constants";
import { getThdLocalizer } from "./storageManager/storageManager";

export const destructureStoreDetails = (store = "") => {
  if (!store) return null;
  
  try {
    const [storeId, storeNameAndCityState] = store.split("+");
    const dashCount = (storeNameAndCityState.match(/-/g) || []).length;
    
    if (dashCount === 1) {
      const [name, cityState] = storeNameAndCityState.split("-");
      const [city, state] = cityState.split(",");
      return { storeId, name: name.trim(), city: city.trim(), state: state.trim() };
    } 
    
    const lastIndexOf = storeNameAndCityState.lastIndexOf(" - ");
    const name = storeNameAndCityState.substring(0, lastIndexOf);
    const cityState = storeNameAndCityState.substring(lastIndexOf + 3);
    const [city, state] = cityState.split(",");
    
    return { storeId, name, city: city.trim(), state: state.trim() };
  } catch (e) {
    console.error("Destructure store details error: ", e);
    const parts = store.split("+");
    return {
      storeId: parts[0] || "",
      name: parts[1]?.trim() || "",
      city: parts[3]?.split(",")[0]?.trim() || "",
      state: parts[4] || ""
    };
  }
};

export const mapStringToStoreHours = (storeHoursInString = "") => {
  const storeHours = {};
  storeHoursInString
    .split(";")
    .filter((_, index) => {
      return index % 2 !== 0;
    })
    .map((openCloseHours) => {
      const hours = openCloseHours.split("-");
      return { open: hours[0], close: hours[1] };
    })
    .forEach((openCloseHours, index) => {
      const day = DAYS[index];
      storeHours[day] = openCloseHours;
    });
  return storeHours;
};

const storeService = {
  getStore() {
    try {
      const { THD_LOCSTORE, THD_STORE_HOURS, THD_STRFINDERZIP } =
        getThdLocalizer() ||
        {};
      const storeHours =
        THD_STORE_HOURS && mapStringToStoreHours(THD_STORE_HOURS);
      const storeObj = destructureStoreDetails(THD_LOCSTORE);
      return {
        storeId: storeObj.storeId,
        name: storeObj.name,
        city: storeObj.city,
        state: storeObj.state,
        zipcode: THD_STRFINDERZIP,
        storeHours: storeHours,
      };
    } catch (e) {
      console.error("Store service error: ", e);
      return null;
    }
  },
  getUserStore() {
    if (userService.status.isUserInStore()) {
      return storeService.getStore();
    }
    return null;
  },
  mapStoreHoursToString(storeHours) {
    return DAYS.map((day, index) => {
      return (
        index + 1 + ";" + storeHours[day].open + "-" + storeHours[day].close
      );
    }).reduce((concatenatedStoreHours, storeHours) => {
      return concatenatedStoreHours
        ? concatenatedStoreHours + ";" + storeHours
        : storeHours;
    });
  },
  mapStringToStoreHours,
};

export default storeService;
